import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";

export default function AdminFeeSheets() {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ service_slug: "cricket-academy", label: "", monthly: "", quarterly: "", annual: "", notes: "" });

  const load = () => api.get("/admin/fee-sheets").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = {
        ...form,
        monthly: form.monthly ? parseFloat(form.monthly) : null,
        quarterly: form.quarterly ? parseFloat(form.quarterly) : null,
        annual: form.annual ? parseFloat(form.annual) : null,
      };
      await api.post("/admin/fee-sheets", payload);
      toast.success("Saved");
      setShow(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => {
    if (!confirm("Delete?")) return;
    await api.delete(`/admin/fee-sheets/${id}`); load();
  };

  return (
    <div data-testid="admin-fee-sheets">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.3em] brand-orange mb-3">// Finance · Fee Sheets</div>
          <h1 className="font-display text-4xl font-black uppercase tracking-tighter leading-none">Fee Pricing Sheets.</h1>
        </div>
        <button onClick={() => setShow(true)} data-testid="new-fee-btn" className="bg-brand-blue text-white px-5 py-2 text-xs uppercase font-bold tracking-widest flex items-center gap-2">
          <Plus size={12} /> New Sheet
        </button>
      </div>

      <div className="border border-white/12 bg-[#131A2B] overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="font-mono text-xs uppercase tracking-widest text-white/40 border-b border-white/12">
              <th className="text-left p-4">Service</th>
              <th className="text-left p-4">Label</th>
              <th className="text-right p-4">Monthly</th>
              <th className="text-right p-4">Quarterly</th>
              <th className="text-right p-4">Annual</th>
              <th className="text-right p-4"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id} className="border-b border-white/5">
                <td className="p-4 font-mono text-xs">{it.service_slug}</td>
                <td className="p-4">{it.label}</td>
                <td className="p-4 text-right font-mono brand-blue">{it.monthly ? "₹" + it.monthly : "-"}</td>
                <td className="p-4 text-right font-mono">{it.quarterly ? "₹" + it.quarterly : "-"}</td>
                <td className="p-4 text-right font-mono">{it.annual ? "₹" + it.annual : "-"}</td>
                <td className="p-4 text-right"><button onClick={() => del(it.id)} className="text-white/60 hover:text-red-400"><Trash2 size={14} /></button></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-white/40">No custom fee sheets. Default catalog rates apply.</td></tr>}
          </tbody>
        </table>
      </div>

      {show && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setShow(false)}>
          <div className="bg-[#131A2B] border border-white/12 p-8 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-display text-2xl uppercase font-black">New Fee Sheet</h3>
              <button onClick={() => setShow(false)}><X size={18} /></button>
            </div>
            <div className="space-y-3">
              <select value={form.service_slug} onChange={(e) => setForm({ ...form, service_slug: e.target.value })} className="w-full bg-[#131A2B] border border-white/20 py-3 px-4">
                <option value="cricket-academy">Cricket Academy</option>
                <option value="football-academy">Football Academy</option>
                <option value="badminton-academy">Badminton Academy</option>
                <option value="gym">Fitness Gym</option>
                <option value="dormitory">Sports Dormitory</option>
                <option value="swimming">Swimming</option>
              </select>
              <input value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} placeholder="Label (e.g. Premium 6-day)" className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <div className="grid grid-cols-3 gap-3">
                <input type="number" value={form.monthly} onChange={(e) => setForm({ ...form, monthly: e.target.value })} placeholder="Monthly" className="bg-transparent border border-white/20 py-3 px-4" />
                <input type="number" value={form.quarterly} onChange={(e) => setForm({ ...form, quarterly: e.target.value })} placeholder="Quarterly" className="bg-transparent border border-white/20 py-3 px-4" />
                <input type="number" value={form.annual} onChange={(e) => setForm({ ...form, annual: e.target.value })} placeholder="Annual" className="bg-transparent border border-white/20 py-3 px-4" />
              </div>
              <textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Notes" rows={2} className="w-full bg-transparent border border-white/20 py-3 px-4" />
              <button onClick={save} data-testid="fee-save" className="w-full bg-brand-blue text-white py-3 font-bold uppercase tracking-widest">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
